<template lang="pug">
  div.timer
    img(src="@/assets/cronometro.gif")    
    div.minutes {{formatTime}}
</template>

<script>
import { mapMutations, mapActions, mapGetters } from 'vuex';

export default {
  name: 'Timer',
   props: { 
    term: {
      type: Number,
      default: 480
    },
  },
  computed: {
    ...mapGetters(['currentStep', 'timer', 'time'])    
  },
  watch: {    
    time: {
      handler(val) {
        this.formatTime = this.$moment(this.time).format('mm:ss');
        this.formatTime = (this.formatTime === 'Invalid date') ? '': this.formatTime;
      }     
    }
  },
  data() {
      return {
          formatTime: ''
      }
  },
  created() {    
    this.formatTime = this.$moment(this.time).format('mm:ss');
    // this.interval = setInterval(this.updateRemaining, 1000);
  },
  methods: {
      ...mapActions(['nextStepSCORM']),
      ...mapMutations(['setCurrentStep']),
      updateRemaining() {
        this.remaining -= 1;
        this.time = this.$moment(this.remaining * 1000).format('mm:ss');
        if (this.remaining === 0) {
            clearInterval(this.interval);
            this.nextStepSCORM();
        }
      }
  }  
}
</script>

<style scoped>
@import 'timer.scss';
</style>
